import { cn } from '../lib/utils'

interface StatusBadgeProps {
  status: string
  className?: string
  size?: 'sm' | 'md' | 'lg'
}

const statusConfig: Record<string, { bg: string; text: string; label: string }> = {
  open: { bg: 'bg-info-light', text: 'text-info', label: 'Open' },
  resolved: { bg: 'bg-success-light', text: 'text-success', label: 'Resolved' },
  contained: { bg: 'bg-warning-light', text: 'text-warning', label: 'Contained' },
  escalated: { bg: 'bg-danger-light', text: 'text-danger', label: 'Escalated' },
  pending: { bg: 'bg-warning-light', text: 'text-warning', label: 'Pending' },
  approved: { bg: 'bg-success-light', text: 'text-success', label: 'Approved' },
  rejected: { bg: 'bg-danger-light', text: 'text-danger', label: 'Rejected' },
  dismissed: { bg: 'bg-gray-100', text: 'text-gray-500', label: 'Dismissed' },
  active: { bg: 'bg-success-light', text: 'text-success', label: 'Active' },
  inactive: { bg: 'bg-gray-100', text: 'text-gray-500', label: 'Inactive' },
}

const sizeClasses = {
  sm: 'px-2 py-0.5 text-xs',
  md: 'px-2.5 py-1 text-sm',
  lg: 'px-3 py-1.5 text-base',
}

export function StatusBadge({ status, className, size = 'sm' }: StatusBadgeProps) {
  const config = statusConfig[status.toLowerCase()] ?? {
    bg: 'bg-gray-100',
    text: 'text-gray-600',
    label: status,
  }

  return (
    <span
      className={cn(
        'inline-flex items-center rounded-full font-medium capitalize',
        config.bg,
        config.text,
        sizeClasses[size],
        className,
      )}
      role="status"
      aria-label={`Status: ${config.label}`}
    >
      {config.label}
    </span>
  )
}
